import React from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#1a1a1a] bg-[#0a0a0a]">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-3">
              <Shield size={16} strokeWidth={1.5} className="text-[#f59e0b]" />
              <span className="font-mono text-sm font-semibold text-[#ededed]">blackwall</span>
            </Link>
            <p className="text-xs text-[#71717a] leading-relaxed max-w-xs">
              The security monitor built for developers who use AI coding tools.
            </p>
          </div>

          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-[#3f3f46] mb-4">Product</p>
            <ul className="space-y-3">
              {[
                { label: "Features", to: "/features" },
                { label: "Detection Catalog", to: "/detection-catalog" },
                { label: "How It Works", to: "/how-it-works" },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-[#71717a] hover:text-[#ededed] transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-[#3f3f46] mb-4">Resources</p>
            <ul className="space-y-3">
              {["Documentation", "GitHub", "Changelog", "Blog"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-[#71717a] hover:text-[#ededed] transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-[#3f3f46] mb-4">Legal</p>
            <ul className="space-y-3">
              {["Privacy Policy", "Terms of Service", "Security"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-[#71717a] hover:text-[#ededed] transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#1a1a1a] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs font-mono text-[#3f3f46]">
            ⠇ Built for developers who trust, but verify.
          </p>
          <p className="text-xs text-[#3f3f46]">© 2025 Blackwall. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
